<template>
  <div>
    <form onsubmit="return false">
      <div class="form-item">
        <span class="password-label">当前密码:</span>
        <input v-model.trim="form.currentPassword" class="password-input" type="password" placeholder="请输入当前密码" maxlength="20">
      </div>
      <div class="form-item">
        <span class="password-label">新密码:</span>
        <input v-model.trim="form.newPasswordA" class="password-input" type="password" placeholder="请输入新密码" maxlength="20">
      </div>
      <div class="form-item">
        <span class="password-label">确认新密码:</span>
        <input v-model.trim="form.newPasswordB" class="password-input" type="password" placeholder="请再次输入新密码" maxlength="20">
      </div>
      <div class="form-item">
        <span class="password-label"></span>
        <button class="password-btn" @click="changePassword">立即修改</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      form: {
        currentPassword: '',
        newPasswordA: '',
        newPasswordB: ''
      }
    }
  },
  methods: {
    changePassword () {
      if (this.form.currentPassword === '' || this.form.newPasswordA === '' || this.form.newPasswordB === '') {
        if (this.form.currentPassword === '') {
          this.$message.error('当前密码不能为空')
          return
        }
        if (this.form.newPasswordA === '') {
          this.$message.error('新密码不能为空')
          return
        }
        if (this.form.newPasswordB === '') {
          this.$message.error('还未输入确认密码')
        }
      } else {
        if (this.form.newPasswordA !== this.form.newPasswordB) {
          this.$message.error('两次输入的新密码不一致，请重新输入')
          return
        }
        if (this.form.newPasswordA === this.form.currentPassword) {
          this.$message.warning('新旧密码一致，密码未做修改')
          return
        }
        const token = sessionStorage.getItem('token')
        if (token !== null) {
          this.updatePassword(token, this.form.newPasswordA, this.form.currentPassword)
        } else {
          this.$message.error('你还未登录')
        }
      }
    },
    updatePassword (token, newPassword, currentPassword) {
      const that = this
      that.axios.put('my/update_password', { token, newPassword, currentPassword }).then(function (resp) {
        console.log(resp.data)
        if (resp.data.code === 1) {
          that.$message.error(resp.data.msg)
        }
        if (resp.data.code === 0) {
          that.$message.success('密码更新成功')
          that.initForm()
        }
      }).catch(function (res) {
        that.$message.error('系统错误，请联系管理员')
      })
    },
    initForm () {
      this.form = {
        currentPassword: '',
        newPasswordA: '',
        newPasswordB: ''
      }
    }
  }
}
</script>

<style scoped>
.password-input{
  padding: 8px;
  font-size: 12px;
  width: 200px;
}
.password-btn{
  width: 200px;
  padding: 8px;
  border-radius: 2px;
  outline: none;
  border-width: 1px;
  cursor: pointer;
}
.password-btn:hover{
  background-color: #000;
  color: white;
}
.password-label{
  display: inline-block;
  width: 90px;
  font-size: 15px;
  padding-right: 10px;
  text-align: right;
}
.form-item{
  padding: 8px 0;
}
</style>
